import { Link } from 'react-router-dom';
import { articles } from '@/mocks/articles';

export default function LatestNews() {
  const latestArticles = articles
    .sort((a, b) => new Date(b.publishDate).getTime() - new Date(a.publishDate).getTime())
    .slice(0, 6);

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading">
              最新资讯
            </h2>
            <p className="text-sm text-foreground-600 mt-1">
              澳门彩最新动态与资讯更新
            </p>
          </div>
          <Link
            to="/category/kaijiang-jieguo"
            className="text-sm text-accent-600 font-medium hover:text-accent-700 transition-colors duration-200 whitespace-nowrap cursor-pointer"
          >
            更多资讯 <i className="ri-arrow-right-line ml-1"></i>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {latestArticles.map((article) => (
            <Link
              key={article.slug}
              to={`/article/${article.slug}`}
              className="group flex gap-4 p-4 rounded-lg bg-background-100 border border-background-200/70 hover:border-primary-300/60 transition-all duration-300 cursor-pointer"
            >
              <div className="w-24 h-24 md:w-28 md:h-28 flex-shrink-0 rounded-lg overflow-hidden">
                <img
                  src={article.coverImage}
                  alt={article.title}
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                />
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1.5 flex-wrap">
                  <span className="text-xs px-2 py-0.5 rounded-full bg-secondary-100 text-secondary-700 font-medium whitespace-nowrap">
                    {article.category === 'wanfa-guize' ? '玩法规则' :
                     article.category === 'kaijiang-jieguo' ? '开奖结果' :
                     article.category === 'goumai-jiqiao' ? '购买技巧' :
                     article.category === 'zhongjiang-gonglve' ? '中奖攻略' :
                     article.category === 'kaijiang-shijian' ? '开奖时间' : '号码分析'}
                  </span>
                  <span className="text-xs text-foreground-500">{article.publishDate}</span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 line-clamp-2 group-hover:text-accent-600 transition-colors duration-200 font-heading">
                  {article.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2 hidden sm:block">
                  {article.excerpt}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}